import types from '../../config/types.js'
import MockServer from './MockServer.js'
import ServiceData from 'Mixins/ServiceData.js'
import MockPagination from './MockPagination.js'

export default {
  mixins: [MockServer, ServiceData, MockPagination],
  data() {
    return {
      intercomDeleteConfirm: {
        active: false,
      },
      gateDisconnectConfirm: {
        active: false,
        loading: false,
      },
      panelDeleteConfirm: {
        active: false,
        loading: false,
      },
      filePopup: {
        file: null,
        opened: false,
      },
      clientPopup: {
        list: [
          {
            id: 'extension',
            label: 'Sip id',
            required: true,
            type: types.components.input,
            width: 12,
            attr: {
              placeholder: 'Sip id',
            },
          },
          {
            id: 'password',
            label: 'Пароль',
            required: true,
            type: types.components.input,
            width: 12,
            attr: {
              placeholder: 'Пароль',
            },
          },
        ],
        title: '',
        subTitle: '',
        value: {},
        opened: false,
      },
      searchTimeOut: null,
      filtersData: { order: 'name', order_type: 'asc' },
      rowsSelected: [],
    }
  },
  computed: {
    filters() {
      return [
        {
          id: 'search',
          type: types.components.input,
          width: 4,
          attr: {
            placeholder: 'Поиск по имени и IP адресу',
          },
        },
      ]
    },
    mockContactPanels() {
      return [
        {
          uid: '1',
          unit_name: 'Шлагбаум у корпуса 3',
          manufacturer: 'Beward',
          access: 'Шлагбаум Калитка',
          users_count: 'Все',
          video_stream: 'активен',
        },
        {
          uid: '2',
          unit_name: 'Вход 3 подъезд',
          manufacturer: 'Beward',
          access: 'Подъздная дверь',
          users_count: 'Подъезд 1, Подъезд 2',
          video_stream: 'не активен',
        },
        {
          uid: '3',
          unit_name: 'Парковка',
          manufacturer: 'Beward',
          access: 'Шлагбаум',
          users_count: 'Все',
          video_stream: 'не подключен',
        },
      ]
    },
    tableColumns() {
      return [
        {
          id: 'name',
          label: 'Название панели',
          onclick: () => {
            this.filtersData.order = 'name'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getCurrentIntercomPanels()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'name',
        },
        {
          id: 'manufacturer',
          label: 'Производитель',
          clickable: false,
        },
        {
          id: 'controlled_devices',
          label: 'Управляемые устройства',
          clickable: false,
        },
        {
          id: 'sections',
          label: 'Пользователи',
          clickable: false,
        },
        {
          id: 'rtsp_url',
          label: 'Видеопоток',
          clickable: false,
        },
      ]
    },

    tableRows() {
      const data = []

      this.panelsList.forEach(panel => {
        // Format controlled devices
        const devicesLabel = panel.controlled_devices
          ? panel.controlled_devices
              .map(d => d.device_type?.name || '')
              .filter(Boolean)
              .join(', ')
          : '-'

        // Format sections
        const sectionsLabel = panel.available_to_all_residents
          ? 'Все'
          : panel.sections
              .map(s => s.section_name || s.section_index)
              .filter(Boolean)
              .join(', ')

        // Format video stream status
        const videoStreamLabel = panel.rtsp_url
          ? panel.is_active
            ? 'Активен'
            : 'Не активен'
          : 'Не подключен'

        data.push({
          id: panel.panel_id,
          columns: [
            {
              id: 'name',
              content: {
                id: panel.panel_id,
                label: panel.name || 'Без названия',
              },
            },
            {
              id: 'manufacturer',
              content: {
                id: panel.panel_id,
                label: panel.manufacturer?.name || '-',
              },
            },
            {
              id: 'controlled_devices',
              content: {
                id: panel.panel_id,
                label: devicesLabel,
              },
            },
            {
              id: 'sections',
              content: {
                id: panel.panel_id,
                label: sectionsLabel,
              },
            },
            {
              id: 'rtsp_url',
              content: {
                id: panel.panel_id,
                label: videoStreamLabel,
              },
            },
          ],
        })
      })

      return data
    },
    actions() {
      return {
        default: [
          {
            id: 1,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Редактировать адрес или сервер',
              icon: 'edit',
              handler: () =>
                this.$router.push({
                  name: 'EditAddress',
                  params: { intercomId: this.$route.params.intercomId },
                }),
            },
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Добавить абонентов через файл',
              icon: 'upload-file',
              handler: () => {
                this.filePopup.opened = true
              },
            },
          },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: 'Отключить адрес',
              icon: 'trash',
              handler: () => {
                this.gateDisconnectConfirm.active = true
              },
            },
          },
        ],

        selected: [
          {
            id: 1,
            type: types.actions.text,
            label: `Выбрано элементов: ${this.rowsSelected.length}`,
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Отменить выделение',
              icon: 'cross',
              handler: () => (this.rowsSelected = []),
            },
          },
          {
            id: 4,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: `${
                this.rowsSelected.length > 1
                  ? 'Удалить панели'
                  : 'Удалить панель'
              }`,
              icon: 'trash',
              handler: () => this.showDeleteConfirmation(),
            },
          },
        ],
      }
    },
    currentIntercom() {
      return this.$store.getters['currentIntercom']
    },
    currentAddress() {
      return this.currentIntercom && this.currentIntercom.property
        ? this.currentIntercom.property.address
        : null
    },
    currentServer() {
      return this.currentIntercom && this.currentIntercom.sip_server
        ? this.currentIntercom.sip_server
        : null
    },
  },
  methods: {
    onDeleteIntercomApprove() {
      this.deleteIntercom(this.$route.params.intercomId)
    },
    onGateDisconnectApprove() {
      this.deleteIntercom(this.$route.params.intercomId)
    },
    getUnitTypeLabel(unitType) {
      const unitTypeMap = {
        flat: 'Квартира',
        parking: 'Паркинг',
        commercial: 'Коммерческое помещение',
        warehouse: 'Кладовая',
        apartment: 'Апартаменты',
      }

      return unitTypeMap[unitType] || unitType
    },
    toggleColumnOrderType(column) {
      this.filtersData.order_type =
        this.filtersData.order === column &&
        this.filtersData.order_type === 'asc'
          ? 'desc'
          : 'asc'
    },

    onSwitcherClick({ row, column, currentValue }) {
      if (column === 'isNotifiable') {
        this.updateContactNotificationStatus(row)
      } else {
        this.verifyContact(row)
      }
    },

    onRowClick(id) {
      const panel = this.panelsList.find(item => item.panel_id === id)
      if (!panel) return

      const panelData = {
        basic: {
          name: panel.name || '',
          sipAccount: panel.sip_account || '',
        },
        network: {
          manufacturer: panel.manufacturer?.id || '',
          ipAddress: panel.ip_address || '',
          login: panel.login || '',
          password: panel.password || '',
          applyToAll: panel.apply_credentials_to_all || false,
          rtspUrl: panel.rtsp_url || '',
        },
        access:
          panel.controlled_devices?.map(device => {
            const usesApi = device.uses_api ?? true
            return {
              deviceTypeId: device.device_type_id,
              lockTypeId: device.lock_type_id || 1,
              usesApi,
              dtmf: usesApi ? '' : device.dtmf || '',
              dtmfCache: usesApi ? device.dtmf || '' : '',
              openLink: device.open_link || '',
              isActive: device.is_active,
              deviceId: device.device_id,
              regenerateLink: false,
            }
          }) || [],
        users: {
          selectedSections: panel.sections?.map(s => s.section_id) || [],
          available_to_all_residents: panel.available_to_all_residents || false,
        },
      }

      this.$store.dispatch('setEditMode', {
        panelId: panel.panel_id,
        panelData: panelData,
      })
      this.$store.dispatch('setToggleAddPanel', true)
    },
    onClientPopupClose() {
      this.clientPopup.opened = false
    },
    onClientPopupApprove() {
      this.contactService
        .updateContact(this.clientPopup.value)
        .then(response => {
          this.$store.dispatch('setNotification', {
            text: 'Запись успешно обновлена',
          })
          this.getCurrentIntercomPanels()

          this.clientPopup.opened = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFilePopupClose() {
      this.filePopup.opened = false
    },
    onFilePopupApprove() {
      this.intercomService
        .addContacts(this.currentIntercom.cuid, {
          contactsFile: this.filePopup.file,
        })
        .then(response => {
          this.getCurrentIntercomPanels()

          this.filePopup.opened = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    verifySelectedContacts() {
      let data = { contacts: [] }
      this.rowsSelected.forEach(value => {
        data.contacts.push({ id: value })
      })
      this.contactService
        .verifyContacts(data)
        .then(response => {
          this.rowsSelected = []
          this.getCurrentIntercomPanels()
        })
        .catch(error => {
          console.log(error)
        })
    },
    verifyContact(contactId) {
      this.contactService
        .verifyContacts({ contacts: [{ id: contactId }] })
        .then(response => {
          this.getCurrentIntercomPanels()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteIntercom(intercomId) {
      this.gateDisconnectConfirm.loading = true
      this.intercomService
        .removeIntercoms([intercomId])
        .then(response => {
          this.gateDisconnectConfirm.active = false
          this.$router.push({ name: 'Intercom' })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.gateDisconnectConfirm.loading = false
        })
    },
    showDeleteConfirmation() {
      // Open the delete confirmation modal
      this.panelDeleteConfirm.active = true
    },
    async onDeletePanels(cuid, panelIds, organizationId) {
      this.panelDeleteConfirm.loading = true

      await this.deletePanels(cuid, panelIds, organizationId)
        .then(async () => {
          // // Show success notification
          // this.$store.dispatch('setNotification', {
          //   text:
          //     panelIds.length > 1
          //       ? 'Панели успешно удалены'
          //       : 'Панель успешно удалена',
          // })

          // Close delete confirmation modal
          this.panelDeleteConfirm.active = false
          await this.getCurrentIntercomPanels()
          // Remove panels from store
          // this.$store.dispatch('removePanel', [...panelIds])

          // Clear selection
          this.rowsSelected = []
        })
        .catch(error => {
          const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.data?.error ||
            'Ошибка при удалении панели'

          this.$store.dispatch('setNotification', {
            type: 'cross-outlined',
            text: errorMessage,
          })
        })
        .finally(() => {
          this.panelDeleteConfirm.loading = false
        })
    },
    filterPanels(filters) {
      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(() => {
        this.filtersData = {
          ...this.filtersData,
          organization_id: this.currentOrganizationId,
          search: filters.search || '',
        }

        this.getFilteredPanels()
      }, 500)
    },
    async getCurrentIntercomPanels() {
      await this.getFilteredPanels()
    },
    setPanelsPagination() {
      this.initPagination(
        this.panelsMeta.current_page,
        this.panelsMeta.total,
        this.panelsMeta.per_page
      )
    },
    async getFilteredPanels() {
      this.filtersData.organization_id = this.currentOrganizationId
      const cuid = this.$route.params.intercomId
      await this.getPanels(cuid, this.filtersData).then(() => {
        this.setPanelsPagination()
      })
    },
    onSwitchPage(page) {
      this.filtersData.page = page
      this.getFilteredPanels()
    },

    updateContactNotificationStatus(contactId) {
      this.contactService
        .updateContactsNotificationStatus({ contacts: [{ id: contactId }] })
        .then(response => {
          this.getCurrentIntercomPanels()
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateContactsNotificationStatus() {
      let data = { contacts: [] }

      this.rowsSelected.forEach(value => {
        data.contacts.push({ id: value })
      })

      this.contactService
        .updateContactsNotificationStatus(data)
        .then(response => {
          this.rowsSelected = []
          this.getCurrentIntercomPanels()
        })
        .catch(error => {
          console.log(error)
        })
    },
  },

  async mounted() {
    // Load reference data
    // await Promise.all([
    //   this.loadManufacturers(),
    //   this.loadControlledDeviceTypes(),
    // ])
    // Load panels
    // this.getCurrentIntercomPanels()
  },
}
